(function () {
  /* =============================================
     ROVE VITAL HOUSE — Quick View
     File: Assets/rove-quickview.js
     ============================================= */

  var currentProduct = null;
  var selectedVariantId = null;

  /* =============================================
     1. COLOR RESOLVER
     3 step fallback:
     1) Custom map (brand specific colors)
     2) Browser CSS resolve (standard color names)
     3) String to unique HSL (koi bhi naam ho)
     ============================================= */
  function getColorHex(colorName) {
    // Step 1 — Brand specific custom map
    var customMap = {
      'forest': '#2a452b',
      'cream': '#eeeadf',
      'natural': '#d4c5a9',
      'dark brown': '#3c281d',
      'brown': '#3c281d',
      'off white': '#eeeadf',
      'off-white': '#eeeadf',
      'sand': '#c8b89a',
      'stone': '#9e8e7e',
      'clay': '#b5694e',
      'rust': '#8b3a2a',
      'sage': '#7a9e7e',
      'olive': '#6b7c4e',
      'charcoal': '#3a3a3a',
      'ivory': '#f5f0e8'
    };

    var key = colorName.toLowerCase().trim();

    // Custom map mein check karo
    if (customMap[key]) return customMap[key];

    // Step 2 — Browser CSS resolver
    // Standard CSS color names jaise red, blue, green etc
    try {
      var tmp = document.createElement('canvas');
      var ctx = tmp.getContext('2d');
      ctx.fillStyle = colorName;
      var resolved = ctx.fillStyle;
      // Agar black nahi aaya matlab browser ne resolve kiya
      if (resolved && resolved !== '#000000') return resolved;
    } catch (e) { }

    // Step 3 — String se unique muted color generate karo
    return stringToMutedColor(colorName);
  }

  // Koi bhi string do — unique muted color banega
  // Brand palette ke saath blend ho aise warm/muted tones
  function stringToMutedColor(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash;
    }
    // Warm hue range (20-200) — brand ke earthy tones se match kare
    var h = Math.abs(hash % 180) + 20;
    var s = 20 + Math.abs((hash >> 4) % 25); // 20-45% saturation (muted)
    var l = 40 + Math.abs((hash >> 8) % 25); // 40-65% lightness (medium)
    return 'hsl(' + h + ',' + s + '%,' + l + '%)';
  }

  // Cream/white jaise light colors pe border lagao
  function needsBorder(colorName) {
    var lightColors = ['cream', 'white', 'ivory', 'off white', 'off-white', 'light', 'snow', 'beige'];
    var key = colorName.toLowerCase().trim();
    return lightColors.some(function (c) { return key.indexOf(c) !== -1; });
  }

  /* =============================================
     2. PRODUCT FETCH
     ============================================= */
  function fetchProduct(handle, callback) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    if (root.slice(-1) !== '/') root += '/';
    fetch(root + 'products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (data) { callback(null, data); })
      .catch(function (err) { callback(err, null); });
  }

  /* =============================================
     3. OPEN QUICK VIEW
     ============================================= */
  window.roveOpenQuickView = function (handle) {
    var overlay = document.getElementById('rove-mOv');
    if (!overlay) return;

    overlay.classList.add('op');
    setLoading(true);

    fetchProduct(handle, function (err, product) {
      if (err || !product) {
        console.error('Product fetch failed:', err);
        setLoading(false);
        overlay.classList.remove('op');
        return;
      }

      currentProduct = product;
      renderModal(product);
      setLoading(false);
    });
  };

  /* =============================================
     4. MODAL RENDER
     ============================================= */
  function renderModal(product) {
    // Image
    var imgEl = document.getElementById('rove-mImg');
    if (imgEl && product.featured_image) {
      imgEl.src = product.featured_image;
    }

    // Title
    var titEl = document.getElementById('rove-mTit');
    if (titEl) titEl.textContent = product.title;

    // View Product link — product URL set karo
    var linkEl = document.getElementById('rove-mLink');
    if (linkEl) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      if (root.slice(-1) !== '/') root += '/';
      linkEl.href = root + 'products/' + product.handle;
    }

    // Default price — pehle variant se
    var prEl = document.getElementById('rove-mPr');
    if (prEl && product.variants && product.variants.length > 0) {
      prEl.textContent = formatPrice(product.variants[0].price);
      selectedVariantId = product.variants[0].id;
    }

    // Variants render
    renderVariants(product);
  }

  /* =============================================
     5. VARIANTS RENDER
     ============================================= */
  function renderVariants(product) {
    // Pehle dono sections reset karo
    hideSection('rove-color-section');
    hideSection('rove-size-section');
    document.getElementById('rove-sws').innerHTML = '';
    document.getElementById('rove-szb').innerHTML = '';

    // Single default variant — koi options nahi
    if (
      product.variants.length === 1 &&
      product.variants[0].title === 'Default Title'
    ) {
      return;
    }

    // Options loop karo
    product.options.forEach(function (option, idx) {
      var name = option.name.toLowerCase().trim();

      if (name === 'color' || name === 'colour' || name === 'colors') {
        renderColorSwatches(option.values, idx);
      } else if (name === 'size' || name === 'sizes') {
        // Size section temporarily hidden — uncomment below to re-enable
        // renderSizeButtons(option.values, idx);
      }
    });
  }

  function renderColorSwatches(values, optionIndex) {
    var section = document.getElementById('rove-color-section');
    var container = document.getElementById('rove-sws');
    var label = document.getElementById('rove-mCol');

    if (!section || !container || values.length === 0) return;

    section.style.display = 'block';

    values.forEach(function (val, i) {
      var sw = document.createElement('div');
      sw.className = 'rove-sw' + (i === 0 ? ' ac' : '');

      // Automatic color resolve — 3 step fallback
      var colorHex = getColorHex(val);
      sw.style.background = colorHex;

      // Light color pe border
      if (needsBorder(val)) {
        sw.style.border = '1px solid rgba(60,40,29,0.25)';
      }

      // Tooltip — hover pe naam dikhega
      sw.setAttribute('title', val);
      sw.setAttribute('data-value', val);
      sw.setAttribute('data-option-index', optionIndex);

      sw.addEventListener('click', function () {
        document.querySelectorAll('#rove-sws .rove-sw').forEach(function (s) {
          s.classList.remove('ac');
        });
        sw.classList.add('ac');
        if (label) label.textContent = val;
        updateVariant();
      });

      container.appendChild(sw);
    });

    // Pehla color label
    if (label && values.length > 0) label.textContent = values[0];
  }

  function renderSizeButtons(values, optionIndex) {
    var section = document.getElementById('rove-size-section');
    var container = document.getElementById('rove-szb');
    var label = document.getElementById('rove-mSz');

    if (!section || !container || values.length === 0) return;

    section.style.display = 'block';

    values.forEach(function (val, i) {
      var btn = document.createElement('button');
      btn.className = 'rove-sz' + (i === 0 ? ' ac' : '');
      btn.textContent = val;
      btn.setAttribute('data-value', val);
      btn.setAttribute('data-option-index', optionIndex);

      btn.addEventListener('click', function () {
        document.querySelectorAll('#rove-szb .rove-sz').forEach(function (b) {
          b.classList.remove('ac');
        });
        btn.classList.add('ac');
        if (label) label.textContent = val;
        updateVariant();
      });

      container.appendChild(btn);
    });

    if (label && values.length > 0) label.textContent = values[0];
  }

  /* =============================================
     6. VARIANT MATCHING
     ============================================= */
  function updateVariant() {
    if (!currentProduct) return;

    var selectedOptions = [];

    var colorBtn = document.querySelector('#rove-sws .rove-sw.ac');
    if (colorBtn) selectedOptions.push(colorBtn.getAttribute('data-value'));

    var sizeBtn = document.querySelector('#rove-szb .rove-sz.ac');
    if (sizeBtn) selectedOptions.push(sizeBtn.getAttribute('data-value'));

    // Match karo
    var matched = currentProduct.variants.find(function (v) {
      return selectedOptions.every(function (opt) {
        return v.title.indexOf(opt) !== -1;
      });
    });

    if (matched) {
      selectedVariantId = matched.id;

      var prEl = document.getElementById('rove-mPr');
      if (prEl) prEl.textContent = formatPrice(matched.price);

      // Image bhi update karo agar variant ki alag image ho
      if (matched.featured_image) {
        var imgEl = document.getElementById('rove-mImg');
        if (imgEl) {
          imgEl.style.backgroundImage = "url('" + matched.featured_image.src + "')";
        }
      }

      var addBtn = document.getElementById('rove-madd');
      if (addBtn) {
        if (matched.available) {
          addBtn.disabled = false;
          addBtn.querySelector('span').textContent = 'Add to Cart';
          addBtn.style.background = '';
        } else {
          addBtn.disabled = true;
          addBtn.querySelector('span').textContent = 'Sold Out';
          addBtn.style.background = 'rgba(60,40,29,0.35)';
        }
      }
    }
  }

  /* =============================================
     7. ADD TO CART
     ============================================= */
  window.roveAddToCart = function () {
    if (!selectedVariantId) return;

    var addBtn = document.getElementById('rove-madd');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.querySelector('span').textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // Cart count update
        document.querySelectorAll('.rove-cart-count').forEach(function (el) {
          el.textContent = 'Cart (' + cart.item_count + ')';
        });

        // Success
        if (addBtn) {
          addBtn.querySelector('span').textContent = 'Added!';
          addBtn.style.background = '#2a452b';
        }

        // 1.2s baad band karo
        setTimeout(function () {
          roveCloseModal();
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.querySelector('span').textContent = 'Add to Cart';
            addBtn.style.background = '';
          }
        }, 1200);
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.querySelector('span').textContent = 'Try Again';
          addBtn.style.background = '';
        }
      });
  };

  /* =============================================
     8. MODAL CLOSE
     ============================================= */
  window.roveCloseModal = function () {
    var overlay = document.getElementById('rove-mOv');
    if (overlay) overlay.classList.remove('op');
    currentProduct = null;
    selectedVariantId = null;
  };

  document.addEventListener('DOMContentLoaded', function () {
    // Overlay click
    var overlay = document.getElementById('rove-mOv');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) roveCloseModal();
      });
    }

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') roveCloseModal();
    });
  });

  /* =============================================
     9. HELPERS
     ============================================= */
  function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function hideSection(id) {
    var el = document.getElementById(id);
    if (el) el.style.display = 'none';
  }

  function setLoading(bool) {
    var body = document.getElementById('rove-mbdy');
    if (body) body.style.opacity = bool ? '0.4' : '1';
  }

})();
